import "../../styles/WidgetIconButton.css";

/**
 * Square icon button for widget header actions (download, view-all, etc).
 * Native title attribute shows the tooltip on hover.
 *
 * Props:
 *  - icon       React element  required
 *  - title      string         required - tooltip + aria-label
 *  - onClick    () => void
 *  - disabled   bool
 */
export function WidgetIconButton({ icon, title, onClick, disabled }) {
  return (
    <button
      type="button"
      className="cp-icon-btn"
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
    >
      {icon}
    </button>
  );
}
